"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hexToRGB = hexToRGB;
exports.canReadText = canReadText;
exports.getLinkUse = getLinkUse;
exports.getTextColor = getTextColor;
exports.getPrimaryColorOrDefault = getPrimaryColorOrDefault;

var _Raven = _interopRequireDefault(require("Raven"));

var _colors = require("HubStyleTokens/colors");

var SHORTHAND_HEX_PATTERN = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
var REGULAR_HEX_PATTERN = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;

function hexToRGB(hex) {
  var rgbObject;

  try {
    var regularHex = hex.replace(SHORTHAND_HEX_PATTERN, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });
    var result = REGULAR_HEX_PATTERN.exec(regularHex);
    rgbObject = {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    };
  } catch (error) {
    _Raven.default.captureMessage('HEX_TO_RGB_ERROR', {
      extra: {
        error: error,
        hex: hex
      }
    });

    rgbObject = {
      r: 0,
      g: 0,
      b: 0
    };
  }

  return rgbObject;
}

function getL(hex) {
  var rgb = hexToRGB(hex);
  var r = rgb.r / 255.0;
  var rL = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
  var g = rgb.g / 255.0;
  var gL = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
  var b = rgb.b / 255.0;
  var bL = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);
  return 0.2126 * rL + 0.7152 * gL + 0.0722 * bL;
}

function canReadText(backgroundHex, textColor) {
  var backL = getL(backgroundHex);
  var textL = getL(textColor);
  var contrastRatio = (textL + 0.05) / (backL + 0.05);
  return contrastRatio > 2.0;
}

function getLinkUse(backgroundHex) {
  var backL = getL(backgroundHex);
  var textL = getL(_colors.CALYPSO); // default link color

  var contrastRatio = (textL + 0.05) / (backL + 0.05);
  return contrastRatio > 2.0 ? 'default' : 'on-dark';
}

function getTextColor(primaryColor) {
  return canReadText(primaryColor, _colors.OLAF) ? _colors.OLAF : _colors.OBSIDIAN;
}
/*
 * Util function to determine the color of text to display against a white
 * background. If the primaryColor is dark enough to render against a white
 * background, use it. Otherwise, use the element's default coloring
 */


function getPrimaryColorOrDefault(primaryColor) {
  return canReadText(primaryColor, _colors.OLAF) ? primaryColor : null;
}